export const cleanBase64ImageData = (imageData: string) => {
  if (!imageData || typeof imageData !== "string") {
    return "";
  }
  const parts = imageData.split("data:image/png;base64,");
  const filteredParts = parts.filter(Boolean);
  const cleanedData = "data:image/png;base64," + filteredParts.join("");
  return cleanedData;
};
